import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "Common/BreadCrumb";
import Select from "react-select";
// Icons
import { Plus, ArrowLeft, SearchIcon } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import CargoDeficitFareColumn from "Common/Components/ColumnData/CargoDeficitFareColumn";

const CargoDeficitFare = () => {
  const [data, setData] = useState<any>([
    {
      id: 1,
      weight: "50,000",
      price: "140,000",
      create_at: "1404-12-2",
    },
    {
      id: 3,
      weight: "1400,000",
      price: "25100,000",
      create_at: "1402-1-2",
    },
    {
      id: 45,
      weight: "952,000",
      price: "17600,000",
      create_at: "1400-1-17",
    },
  ]);
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  const [isEdit, setIsedit] = useState<boolean>(false);
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();

  const userData = null;
  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;

    const totalItems = alldata ? Number(alldata) : 0;

    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize); // تنظیم سایز جدید
    setCurrentPage(newPage); // تنظیم صفحه جدید

    // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
    fetchData(newPage, newSize);
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, size, reload, searchValue]);

  // Get Data
  const fetchData = async (page: any, size: any) => {
    try {
      // ساخت URL پایه
      //   let url = `https://api.havirkesht.ir/farmer/?sort_by=updated_at&sort_order=desc&size=${size}&page=${page}`;
      //   if (searchValue && searchValue.trim() !== "") {
      //     url += `&search=${encodeURIComponent(searchValue.trim())}`;
      //   }
      //   const res: any = await axios.get(url, {
      //     headers: {
      //       Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
      //     },
      //   });
      //   const items = res?.data?.items || [];
      //   setData(items);
      //   setalldata(res?.data?.total);
      //   setTotalPages(res?.data?.pages);
      //   setload(items.length < 1); // اصلاح شده به <1 به جای <0
    } catch (error: any) {
      console.error("Error fetching data:", error);
      setErrorMessage(
        error.response
          ? "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
          : "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
      );
      setload(true);
    }
  };

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      try {
        const res = await axios.delete(
          `https://api.havirkesht.ir/product-price/${eventData}`
        );
        if (res.status === 200) {
          toast.success("عملیات حذف با موفقیت انجام شد");
          setreload(!reload);
        } else {
          toast.error("مشکل در خذف داده");
        }
        setDeleteModal(false);
        setEventData(null);
      } catch (error) {
        toast.error("مشکل در حذف داده ");
      }
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      weight: "",
      price: "",
    },
    validationSchema: Yup.object({
      weight: Yup.number().required("لطفاً وزن را وارد کنید"),
      price: Yup.number().required("لطفاً مبلغ را وارد کنید"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await axios.post("https://keshtapdi.havirdam.ir/یس/");
        if (res.status === 201) {
          toast.success("اطلاعات با موفقیت ثبت شد");
          setreload(!reload);
        }
      } catch (error) {
        toast.error("خطا در ثبت اطلاعات");
      } finally {
        toggle();
      }
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsedit(false);
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = CargoDeficitFareColumn({ onClickDelete });

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت کسری بار" title="هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      <div className="bg-white dark:bg-gray-800 dark:text-white dark:border-gray-500 rounded-lg border border-gray-200 p-4">
        <div className="grid  grid-cols-2 md:grid-cols-3 gap-4">
          {[
            { label: "نام راننده :", value: userData },
            { label: "شماره همراه راننده :", value: userData },
            { label: "وزن بار :", value: userData },
            { label: "وزن خاک ", value: userData },
            { label: "درصد افت: ", value: userData },
            { label: "تاریخ تحویل:", value: userData },
          ].map((item, index) => (
            <div key={index} className="space-y-1 flex items-center gap-2">
              <p className="text-xs bold text-gray-500 dark:text-gray-200">
                {item.label}:
              </p>
              <p className="text-sm font-medium">{item.value || "-"}</p>
            </div>
          ))}
        </div>
      </div>
      {errorMessage && <div>{errorMessage}</div>}
      <div className="flex w-96"></div>
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex items-center flex-col md:flex-row gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع کسری بار (
              <b className="total-Employs">{alldata?.toString()}</b>)
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute inset-y-0 left-2 flex items-center text-gray-400">
                    <SearchIcon />
                  </span>
                </div>
              </label>
            </h6>
            <div className="w-full sm:w-auto">
              <TableDropDownSmall onSelect={handleSelect} />
            </div>
            <div className="shrink-0">
              <Link
                to=""
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl"> ثبت کسری بار </span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
              <Link
                to="/Cargo"
                type="button"
                className="text-white btn mr-2 bg-green-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">بازگشت </span>{" "}
                <ArrowLeft className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns || []}
              isGlobalFilter={false}
              data={data || []}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
          {/* صفحه‌بندی */}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">ثبت کسری بار</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 mr-6 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
                <div className="flex flex-col">
                  <label
                    htmlFor="weight"
                    className="text-base font-medium mb-1"
                  >
                    وزن:
                  </label>
                  <input
                    type="number"
                    id="weight"
                    className="form-input text-black font-[12px] w-full"
                    placeholder="0"
                    name="weight"
                    autoComplete="off"
                    onChange={validation.handleChange}
                    value={validation.values.weight}
                  />
                  {validation.touched.weight && validation.errors.weight && (
                    <p className="text-red-400 mt-1">
                      {validation.errors.weight}
                    </p>
                  )}
                </div>
                <div className="flex flex-col">
                  <label
                    htmlFor="weight"
                    className="text-base font-medium mb-1"
                  >
                    مبلغ:
                  </label>
                  <input
                    type="number"
                    id="price"
                    className="form-input text-black font-[12px] w-full"
                    placeholder="0"
                    name="price"
                    autoComplete="off"
                    onChange={validation.handleChange}
                    value={validation.values.price}
                  />
                  {validation.touched.price && validation.errors.price && (
                    <p className="text-red-400 mt-1">
                      {validation.errors.price}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            ثبت اطلاعات
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default CargoDeficitFare;
